exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search-dropdown{position:absolute;color:#1b2733;z-index:100;background-color:#fff;box-shadow:0 2px 12px 0 rgba(0,0,0,.2);border-radius:2px;overflow:hidden;min-width:172px;height:auto!important}.search-dropdown div{margin:0!important;float:none!important}.search-dropdown .dropdown-item-list{padding:8px 0}.common-fade-enter-active,.common-fade-leave-active{transition:max-height .3s;max-height:800px;-webkit-backface-visibility:hidden;backface-visibility:hidden}.common-fade-enter,.common-fade-leave-to{max-height:0}", ""]);

// exports
